import { Link } from "react-router-dom";
import { NAV, SOCIALS, SHOPS, ADDRESS, EMAIL, PHONE_DISPLAY, WEBSITE, WEBSITE_HOST } from "@/lib/site";
import { useLang } from "@/context/LangContext";

export const Footer = () => {
  const { t } = useLang();
  return (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[var(--leaf-deep)] text-white">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 pt-20 pb-10">
      <p className="font-display text-[15vw] sm:text-[11vw] lg:text-[9rem] font-black leading-[0.85] tracking-tighter text-white/95">
        For Better<br /><span className="text-[#7fd49a]">World.</span>
      </p>
      <div className="mt-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 text-sm">
        <div>
          <img src="/assets/img/logo-white.webp" alt="Minaqu Indonesia" className="h-12 w-auto" />
          <p className="mt-4 text-white/80 leading-relaxed">{ADDRESS}</p>
        </div>
        <div>
          <p className="eyebrow !text-[#9be0b0]">{t("Halaman", "Pages")}</p>
          <ul className="mt-4 space-y-2">{NAV.map((n) => <li key={n.to}><Link data-testid={`footer-link-${n.id}`} to={n.to} className="text-white/85 hover:text-white">{t(n.label, n.en)}</Link></li>)}</ul>
        </div>
        <div>
          <p className="eyebrow !text-[#9be0b0]">{t("Sosial & Toko", "Social & Shops")}</p>
          <ul className="mt-4 space-y-2">
            {[...SOCIALS, ...SHOPS.slice(1)].map((s) => <li key={s.id}><a data-testid={`footer-ext-${s.id}`} href={s.href} target="_blank" rel="noreferrer" className="text-white/85 hover:text-white">{s.label}</a></li>)}
          </ul>
        </div>
        <div>
          <p className="eyebrow !text-[#9be0b0]">{t("Kontak", "Contact")}</p>
          <ul className="mt-4 space-y-2 text-white/85">
            <li>{PHONE_DISPLAY}</li><li><a href={`mailto:${EMAIL}`} data-testid="footer-email" className="hover:text-white">{EMAIL}</a></li>
            <li><a href={WEBSITE} data-testid="footer-website" className="hover:text-white">{WEBSITE_HOST}</a></li>
          </ul>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-2 border-t border-white/15 pt-6 text-xs text-white/70 sm:flex-row sm:justify-between">
        <span>© 2026 Minaqu Indonesia. Indonesia Trusted Ornamental Plant Supplier.</span>
        <span>{t("Tumbuh sejak 10 November 2019 · Bogor, Jawa Barat", "Growing since 10 November 2019 · Bogor, West Java")}</span>
      </div>
    </div>
  </footer>
  );
};
